module.exports = __webpack_public_path__ + "img/hangout.c99dc304.png";